module.exports = __webpack_public_path__ + "img/bluesky3100_24.ee9d245e.jpg";